<div class="d-flex justify-content-between border-top bg-light">
  <!-- <small class="{{environment}} text-uppercase" [ngClass]="{'ms-3': isHandheld, 'ms-8': !isHandheld}">{{environment}}</small> -->
   <small>&nbsp;</small>
  <ng-container *ngTemplateOutlet="content"></ng-container>
  <small class="right me-3">{{version}}</small>
</div>

<ng-template #content>
  <a class="mx-auto text-decoration-none text-muted" href="https://www.tdwilliamson.com" rel="noopener" target="_blank">
    <small> &copy; {{year}} T.D. Williamson, Inc.</small></a>
</ng-template>
